import { Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import logoMinExt from 'assets/images/Logo_oficial_del_Ministerio_Relaciones_Exteriores_de_El_Salvador.png';

export const Guidelines = () => {
  return (
    <>
      <div style={{ paddingRight: 70, paddingLeft: 70, paddingTop: 20 }}>
        <Grid container justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={4}>
            <Stack justifyContent={'center'}>
              <img src={logoMinExt} alt="Asamblea Legislativa" />
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <br />
            <Typography align="center" variant="h2" component="h3">
              LINEAMIENTO PARA LA EJECUCIÓN DEL PROCEDIMIENTO ADMINISTRATIVO ESTABLECIDO EN LA LEY GENERAL PARA LA MODERNIZACIÓN DIGITAL DEL
              ESTADO
            </Typography>
          </Grid>
        </Grid>
        <br />
        <br />
        <div style={{ textAlign: 'justify' }}>
          <ol type="I">
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>INTRODUCCIÓN.</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Mediante Decreto Legislativo No. 840, de fecha 5 de septiembre de 2023, al Asamblea Legislativa promulgó al Ley General para
                al Modernización Digital del Estado (LGMDE); mismo que fue publicado en el Diario Oficial No. 166, Tomo No. 440, de fecha
                7de septiembre de 2023, cuyo objetivo es establecer las disposiciones necesarias para la implementación, desarrollo,
                transformación digital y modernización del Estado Salvadoreño, reconociendo de manera general y obligatoriamente, los
                compromisos internacionales que el Estado adquiera para tal fin y en particular los derivados de la Alianza Estratégica
                suscrita entre el Gobierno de la República de El Salvador y Google LLC.
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Como parte de los compromisos adquiridos por el Gobierno de El Salvador en la Alianza Estratégica es encuentra: (i) celebrar
                contratos mutuamente aceptables para la compra de bienes y servicios, incluyendo el desarrollo de infraestructura, durante
                un período no menor a siete (7) años; (ii) celebrar los acuerdos de afiliación entre cada una de las instituciones con el
                Socio Estratégico; y (iii) gestionar los requerimientos de necesidades a través de la &quot;orden de pedido&quot; o
                &quot;formulario de pedido&quot;, el cual será desarrollado por las Partes y podrá ser modificado por mutuo acuerdo.
              </Typography>
              <br />
            </li>
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>GLOSARIO.</strong>
              </Typography>
              <br />
              <ol type="a">
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Acuerdo de Afiliación Individualizado:</strong> Documento estándar aprobado por el Gobierno de El Salvador de
                    conformidad a la Ley General para la Modernización Digital del Estado (LGMDE), que opera bajo la figura de adhesión
                    frente al Acuerdo Maestro de Nube.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Acuerdo Maestro de Google Cloud [o Acuerdo de Nube]:</strong> Contrato compuesto por los Términos Generales del
                    Contrato Maestro de Google Cloud y todos los Anexos de Servicios y Formularios de Pedido que se incorporan por
                    referencia en el Contrato Maestro de Google Cloud, y se celebra entre Google LLC, y el Gobierno de la República de El
                    Salvador, representado por el Ministerio de Relaciones Exteriores.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Alianza Estratégica: </strong>Significa el Acuerdo de Alianza Estratégica entre las partes vigente a partir del
                    23 de agosto de 2023, y sus correspondientes enmiendas o modificaciones.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Anexo de Servicios Aplicables:</strong> Es un complemento que se incorpora por referencia al Contrato Maestro de
                    Google Cloud. Dicho anexo de servicios aplica únicamente a los servicios y al software descrito en el mismo.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Autoridad Firmante de la Alianza:</strong> Se refiere al Ministerio de Relaciones Exteriores, como dependencia
                    del Órgano Ejecutivo facultada para suscribir la Alianza en nombre del Estado y Gobierno de El Salvador.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Catálogo de Servicios del Oferente:</strong> Comprende el listado de bienes y servicios ofrecidos por los
                    oferentes, a través del Portal Web.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Cliente Relevante:</strong> Entidad del Estado que suscribe el Acuerdo de Afiliación Individualizado quedando
                    habilitada para gestionar los requerimientos de necesidades, junto con los beneficios, términos y condiciones
                    correspondientes establecidos en la Alianza Estratégica, el Acuerdo Maestro de Google Cloud, y sus anexos.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Comité Ejecutivo (CE):</strong> Órgano administrativo encargado de supervisar, revisar y coordinar las
                    actividades establecidas en el Acuerdo de Alianza.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Comité Directivo Conjunto (CDC): </strong>Órgano administrativo encargado de la supervisión, de la
                    implementación y las operaciones cotidianas respecto de las actividades y obligaciones en virtud del Acuerdo de Alianza.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Entidades del Estado: </strong>las señaladas en el artículo 3, inciso segundo de la LGMDE. También denominadas
                    &quot;instituciones&quot;.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Información Confidencial: </strong>significa información que una parte o su Afiliada (la &quot;Parte
                    Divulgadora&quot;) divulgue a la otra parte (la &quot;Parte Receptora&quot;), en virtud del Contrato y que se marca como
                    confidencial o que, normalmente, se consideraría información confidencial en esas circunstancias. Los datos del cliente
                    son considerados Información confidencial del cliente. La Información Confidencial no incluye información que la Parte
                    Receptora desarrolló de manera independiente, que un tercero sin obligaciones de confidencialidad compartió con la Parte
                    Receptora o que se haga pública por motivos no imputables a la Parte Receptora.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Oferente: </strong>Persona natural o jurídica que haya enviado su propuesta técnica y económica a la Entidad del
                    Estado a través de una Solicitud de Expresión de Interés. Los oferentes de la Alianza pueden ser el Socio Estratégico,
                    terceros proveedores de servicios y software establecidos en el Google Cloud Marketplace y Partners, socios o
                    distribuidores calificados por el Socio Estratégico.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Orden de Pedido [formulario de pedido o contrato]:</strong> La orden de pedido según sea el caso es:
                  </Typography>
                  <ol type="i">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        el documento por medio del cual el oferente se obliga a la entrega de los servicios conforme a los términos
                        ofrecidos y, a su vez, obliga a las entidades del Estado a realizar el pago correspondiente;
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        una especificación de trabajo u otro documento de pedido emitido por Google en virtud del Contrato y ejecutado por
                        el Cliente y Google;
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        un pedido realizado por el Cliente a través del Portal Web que el Socio Estratégico habilite, en cada caso
                        especificando los Servicios que Google proporcionará al Cliente en virtud del Anexo de Servicios aplicable.
                      </Typography>
                    </li>
                  </ol>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Servicios:</strong> los bienes y servicios, incluyendo el desarrollo de infraestructura, que ofrece el socio
                    estratégico.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Socio Estratégico:</strong> Google LLC, o cualquiera de sus afiliadas, subsidiarias, sucursales, u personas
                    jurídicas controladas por o -bajo el control al que está sujeta- al misma, sus sucesores o cesionarios respecto de
                    Alianza Estratégica.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Planificación Anual de Compras o PAC:</strong> Documento clave que sirve como herramienta de administración por
                    medio de la cual la institución supervisa las actividades de contratación de la Unidad de Compras Públicas, y la
                    Dirección Nacional de Compras puede monitorear la realización de lo planificado.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Partner, Socio o distribuidor: </strong>Entidad autorizada y calificada por Google a quien las instituciones
                    podrán enviar órdenes de pedido.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Portal Web: </strong>Sitio en línea que servirá como entrada principal y acceso a información, aplicaciones,
                    herramientas y otros recursos digitales de manera fácil y eficiente según lo determine el Comité Directivo Conjunto para
                    el desarrollo y operativización de la Alianza Estratégica.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Programas de Servicios Aplicables:</strong> Se refiere al conjunto de términos aplicables a los Servicios de
                    Google que forman parte de un Acuerdo Maestro de Google Cloud según el acuerdo mutuo de las partes y que rigen el uso
                    por parte de la Autoridad de esos Servicios de Google específicos...
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Proceso Especial de Alianza Estratégica:</strong> Denominación que se utiliza para el procedimiento para la
                    gestión de requerimientos de necesidades de servicios al Socio Estratégico y emisión de orden de pedido, de conformidad
                    al presente lineamiento.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Representante de la Entidad:</strong> Persona delegada por el titular o máxima Autoridad de la institución que
                    se encargará de ser el enlace con los órganos de administración de la Alianza.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Unidad Solicitante:</strong> Unidad organizativa de cada institución del Estado encargada de identificar y
                    requerir los bienes y servicios para satisfacer las necesidades institucionales.
                  </Typography>
                </li>
              </ol>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>MARCO JURÍDICO.</strong>
              </Typography>
              <br />
              <ol>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    Ley General para la Modernización Digital del Estado, D.L. No. 840, de fecha 6 de septiembre de 2023, D.O. No. 166, Tomo
                    No. 440, de fecha 7 de septiembre de 2023.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    Acuerdo de Alianza Estratégica, de fecha 23 de agosto de 2023, suscrito entre el Ministerio de Relaciones Exteriores en
                    representación del Gobierno de la República de El Salvador y Google LLC., y sus correspondientes enmiendas
                  </Typography>
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    Acuerdo Maestro de Google Cloud, de fecha 30 de septiembre de 2023, suscrito entre el Ministerio de Relaciones
                    Exteriores en representación del Gobierno de la República de El Salvador y Google LLC.
                  </Typography>
                </li>
                <Typography style={{ fontSize: 15 }}>
                  <li>Acuerdos y resoluciones emitidas por el Comité Ejecutivo.</li>
                </Typography>
                <Typography style={{ fontSize: 15 }}>
                  <li>Acuerdos y resoluciones emitidas por el Comité Directivo Conjunto.</li>
                </Typography>
              </ol>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>OBJETO.</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                El presente lineamiento tiene por objeto establecer las normas básicas que regularán el procedimiento administrativo para la
                gestión de requerimientos de bienes y servicios, incluyendo el desarrollo de infraestructura que ofrezca el oferente a las
                entidades del Estado salvadoreño, aplicando los principios de transparencia, vigencia tecnológica, sostenibilidad social y
                ambiental, razonabilidad del gasto público, eficiencia y eficacia, procurando la optimización de los recursos, a la
                innovación y la creación de valor, contribuyendo de esta forma con el desarrollo y modernización del Estado salvadoreño.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>ALCANCE.</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Este lineamiento será de obligatorio cumplimiento durante al vigencia de la Alianza Estratégica para todas las instituciones
                del Estado, sus dependencias y organismos auxiliares; los Órganos Ejecutivo, Legislativo y Judicial; las instituciones
                oficiales autónomas, así como las empresas estatales, inclusive al Comisión Ejecutiva Hidroeléctrica del Roí Lempa, el
                Instituto Salvadoreño del Seguro Social y las municipalidades.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>ÓRGANOS DE GOBIERNO.</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                La Alianza Estratégica celebrada entre el Gobierno El Salvador con Google LLC, establece al creación de órganos de gobierno
                de la Alianza con el objetivo de procurar su operativización y la resolución de controversias de común acuerdo entre Las
                Partes. Los órganos de gobierno de la Alianza son:
              </Typography>
              <br />
              <ol>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Comité Ejecutivo:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Las partes del Acuerdo de la Alianza Estratégica establecerán un Comité Ejecutivo el cual será el responsable de
                    supervisar, revisar y coordinar las actividades del Acuerdo de Alianza.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>El Comité Ejecutivo estará integrado por:</Typography>
                  <br />
                  <ol type="i">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        dos (2) altos ejecutivos, uno por cada Parte, cada uno de los cuales podrá ser reemplazado mediante notificación por
                        escrito a la otra Parte (cada uno, un &quot;Director Ejecutivo del Programa&quot;); y
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        hasta tres (3) partes interesadas ejecutivas adicionales de cada Parte, según lo asignado por el Director Ejecutivo
                        del Programa respectivo de las Partes. El Comité Ejecutivo permanecerá en vigor durante toda la Vigencia de la
                        Alianza.
                      </Typography>
                    </li>
                  </ol>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Cada Director Ejecutivo del Programa tendrá el tiempo, las habilidades y la experiencia necesarios para servir en dicha
                    capacidad de alto nivel en el Comité Ejecutivo y para cumplir con las responsabilidades de Director Ejecutivo del
                    Programa determinados en la Alianza.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>El Comité Ejecutivo tendrá las responsabilidades siguientes:</Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        El Comité Ejecutivo supervisará el desempeño de las Partes en virtud de la Alianza Estratégica y trabajará de buena
                        fe para mantener la alineación entre las Partes en virtud de la Alianza. El Comité Ejecutivo conocerá las
                        Controversias y los asuntos escalados que no pudiesen ser resueltos por el CDC y que surjan de la Alianza
                        Estratégica.
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Si una Controversia no puede ser resuelta mediante un escalamiento al Comité Ejecutivo dentro de los sesenta (60)
                        días posteriores al escalamiento a través de una notificación por escrito, cualquiera de las Partes podrá utilizar
                        los mecanismos de solución de controversias establecidos en el presente lineamiento.
                      </Typography>
                    </li>
                  </ol>
                  <br />
                </li>
                <Typography style={{ fontSize: 15 }}>
                  Cada Director Ejecutivo del Programa supervisará a sus respectivos representantes de las partes interesadas del Comité
                  Ejecutivo.
                </Typography>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Comité Directivo Conjunto (CDC):</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Las partes del Acuerdo de la Alianza Estratégica establecerán un Comité Directivo Conjunto el cual será responsable de
                    la supervisión de la implementación y las operaciones cotidianas respecto de las actividades y obligaciones en virtud
                    del Acuerdo de Alianza.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    El CDC estará compuesto por: (i) dos (2) miembros, un (1) miembro de cada Parte según sea designado por el director
                    ejecutivo del Programa de cada Parte, quien, para la parte del Gobierno de El Salvador, será además el Gerente de la
                    Alianza, quien podrá ser reemplazado mediante notificación por escrito a la otra Parte (cada uno, un &quot;Miembro del
                    CDC&quot;) y (ii) hasta tres (3) miembros interesados adicionales de cada Parte, según sea designado por cada Parte.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    El CDC permanecerá válido durante toda al Vigencia de la Alianza. Cada miembro del CDC tendrá el tiempo, las habilidades
                    y la experiencia necesarios para servir en dicha capacidad de miembro en el CDC y para cumplir con las responsabilidades
                    que se contempla en la Alianza.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    El CDC será responsable de la supervisión de las actividades cotidianas de la Alianza Estratégica, incluido el
                    seguimiento del progreso de la relación, al presentación de informes al Comité Ejecutivo sobre cuestiones y temas clave;
                    y cualesquiera otras facultades que determine el Acuerdo Maestro de Google Cloud.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>El CDC tendrá, entre otras, las responsabilidades siguientes:</Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Supervisar las actividades cotidianas de la Alianza Estratégica, incluido el seguimiento del progreso de la relación
                        y la presentación de informes al Comité Ejecutivo sobre cuestiones y temas clave.
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Coordinar presentaciones robustas de Google y los representantes de las Afiliadas de Google, así como las
                        discusiones con la Autoridad y los Clientes Relevantes con respecto a los productos, características y usos de
                        Google y las Afiliadas de Google; dicha coordinación incluye la facilitación de la idoneidad de los productos y
                        opciones de precios favorables para dichos productos (incluyendo otros créditos, descuentos, promociones y
                        similares) así como la evaluación del uso más eficiente y efectivo de los productos, considerados en conjunto, para
                        evitar la superposición de productos, a la no utilización de productos o el uso ineficiente de los mismos.
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Resolver cualquier controversia y asuntos escalados que no pudieron ser resueltos por los Gerentes de la Alianza.
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Escalar a través de una notificación por escrito al Comité Ejecutivo cualquier Controversia que no puedan resolver
                        en un plazo de sesenta (60) días.
                      </Typography>
                    </li>
                  </ol>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Gerente de la Alianza:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    El Gerente de la Alianza por parte del Gobierno de El Salvador tendrá, entre otras, las responsabilidades siguientes:
                  </Typography>
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Informar a las entidades del Estado que hayan suscrito el Acuerdo de Afiliación sobre cambios importantes relativos
                        a los Servicios de Google, el CMA y la Alianza en general.
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>Resolver las controversias que surjan relacionadas con la Alianza.</Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Escalar al CDC, mediante una notificación por escrito, cualquier controversia que no puedan resolver en un plazo ed
                        sesenta (60) días.
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Comunicar al CDC las solicitudes de suscripción del Acuerdo de Afiliación por parte de las Entidades del Estado.
                      </Typography>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>CONSIDERACIONES PRELIMINARES:</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Previo al inicio del procedimiento administrativo regulado por la Ley General para la Modernización Digital del Estado, las
                instituciones deben considerar:
              </Typography>
              <br />
              <ol>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Socio Estratégico, Google Cloud Marketplace y Partners, Socios o Distribuidores Calificados.</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Bajo los beneficios de la Alianza Estratégica, las instituciones podrán adquirir bienes y servicios por parte de:
                  </Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        El Socio Estratégico o cualquiera de sus afiliadas, subsidiarias, sucursales o personas jurídicas controladas por o
                        -bajo el control al que está sujeta- al misma, sus sucesores o cesionarios;
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Terceros proveedores de servicios y software disponibles en el Google Cloud Marketplace establecido por el Socio
                        Estratégico; y
                      </Typography>
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Partners, Socios o distribuidores calificados por Google que ofrezcan servicios de gestión de proyectos,
                        implementación, personalización, gestión de cambios, capacitación, configuración, evaluación del entorno de
                        Tecnologías de la Información (TI) o migración de datos, que participen en la implementación o despliegue de los
                        servicios de Google aplicables por parte de las entidades del Estado. No son elegibles las pruebas de concepto,
                        piloto ni talleres.
                      </Typography>
                    </li>
                  </ol>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Previo a la formalización de la adquisición por medio de la orden de pedido, cuando se trate de financiamiento por
                    donaciones o empréstitos, las instituciones del Estado deberán verificar y dejar constancia que los Terceros Proveedores
                    y/o los Socios calificados no se encuentran en el Registro de Sanciones de COMPRASAL, procediendo a realizar la consulta
                    a la Unidad de Compras Públicas (UCP), asimismo, se verificará que no se encuentran en las listas de sancionados con
                    inhabilitación para contratar que el cooperante u organismo multilateral establezca o sugiera.
                  </Typography>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Suscripción del Acuerdo de Afiliación Individualizado:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Las Entidades del Estado podrán suscribir el Acuerdo de Afiliación Individualizado con Google LLC, o cualquiera de sus
                    afiliadas, subsidiarias, sucursales, o personas jurídicas controladas por -o bajo el control al que está sujeta- la
                    misma, sus sucesores o cesionarios
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Dicho acuerdo es un documento estándar aprobado por el Gobierno de El Salvador de conformidad a la Ley General para la
                    Modernización Digital del Estado (LGMDE), que opera bajo la figura de adhesión. Las Instituciones que estén interesadas
                    en suscribir el Acuerdo de Afiliación deberán notificar al Comité Directivo Conjunto a través del Portal Web para su
                    aprobación.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    La suscripción del Acuerdo de Afiliación es el acto habilitante para ejecutar la gestión de requerimientos de
                    necesidades, y obtener la calidad de Cliente Relevante con los beneficios, términos y condiciones correspondientes
                    establecidos en la Alianza Estratégica, el Acuerdo Maestro de Google Cloud, y sus anexos; por lo que, no constituye
                    compromiso de fondos ni presupuesto.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Representante de la Entidad del Estado:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Posterior a la suscripción del Acuerdo de Afiliación, cada Entidad del Estado, mediante acuerdo de la Máxima Autoridad,
                    nombrará un Representante de su institución para la Alianza Estratégica, quien será el enlace institucional con el
                    Gerente de la Alianza.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Este Representante, también denominado &ldquo;Representante Institucional&ldquo; será el competente de comunicar al
                    Gerente de la Alianza las necesidades y requerimientos de adquisiciones y contrataciones, los incumplimientos reportados
                    por los supervisores de la orden de pedido, así como gestionar al información que el Gerente de la Alianza requiera de
                    la institución y viceversa.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Competente para la emisión de orden de pedido y a aprobación de evaluaciones.</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    La Máxima Autoridad de cada Institución será al competente para la emisión de orden de pedido y la aprobación de
                    evaluaciones, quienes están facultadas para delegar esta atribución en inferiores jerárquicos de la misma institución.
                  </Typography>
                  <br />
                </li>
              </ol>
            </li>
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>PROCEDIMIENTO ADMINISTRATIVO.</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Las Entidades del Estado que hayan suscrito el Acuerdo de Afiliación podrán realizar el procedimiento siguiente:
              </Typography>
              <br />
              <ol>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Planificación Anual de Compras:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Las instituciones ejecutoras deberán registrar en la Planificación Anual de Compras (PAC) regulada por la Ley de Compras
                    Públicas, todas las adquisiciones que lleven a cabo conforme al presente lineamiento, estos procedimientos de compra se
                    identificarán y registrarán en dicha Programación con la denominación &ldquo;Proceso Especial de Alianza Estratégica
                    (PEAE)&ldquo;. Dicho registro podrá realizarse posterior a la emisión de la orden de pedido.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    En los casos en los que se requiera adquirir servicios que no se encuentren incluidos en la APC o cuando esta requiera
                    modificaciones, podrá realizarse el proceso de adquisición regulado en el presente lineamiento debiendo registrar
                    posteriormente la modificación de la PAC de acuerdo con el lineamiento correspondiente.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Identificación de Necesidades:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Una vez suscrito el acuerdo de afiliación, cada institución identificará sus necesidades de contratación y a través de
                    la Unidad correspondiente elaborará una solicitud de requerimiento.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Dicha solicitud será remitida al Representante Institucional junto con las especificaciones técnicas y cualquier
                    información relevante para la adquisición, tales como la propuesta de evaluador y del supervisor de la orden de pedido.
                    El objeto de la solicitud de requerimiento podrá ser la recepción de propuestas de solución técnica ante al necesidad
                    planteada por parte del Oferente.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    El requerimiento podrá formalizarse por medio de memorándum o el formulario que la institución elabore para tales
                    efectos.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Cuando el Solicitante sea el mismo Representante Institucional, no será necesaria la elaboración de solicitud, quien
                    procederá directamente a la verificación y notificación regulado en el numeral siguiente.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Recepción del Requerimiento y notificación al Socio Estratégico:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    El Representante Institucional recibirá las solicitudes con la información correspondiente, quien verificará si el
                    objeto de la contratación se trata de los Servicios brindados por el Oferente que se encuentran listados en Catálogo,
                    pudiendo concurrir los casos siguientes:
                  </Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        El servicio se encuentra dentro del Catálogo de servicios Google Cloud que permite la generación de cotización en el
                        portal: En este caso, el Representante Institucional, gestionará la cotización y procederá a su descarga, y a
                        continuación se realizará al evaluación de los datos ofrecidos por el Oferente.
                      </Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        El servicio es encuentra dentro del Catálogo de servicios Google Cloud, debiendo, por su naturaleza, generarse una
                        propuesta, derivado de una previa revisión por parte del Socio Estratégico: Ante este caso, el Representante
                        Institucional formulará el requerimiento yol comunicará al Socio Estratégico a través del Portal Web o mediante el
                        medio electrónico habilitado para tales efectos (notificación) y se otorgará un plazo no mayor a veinte (20) días
                        hábiles para la presentación de propuestas.
                      </Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        El servicio no se encuentra dentro del Catálogo de servicios Google Cloud: En este caso, el Representante
                        Institucional comunicará dicho resultado al solicitante, para que proceda a realizar el proceso de adquisición bajo
                        al legislación aplicable.
                      </Typography>
                      <br />
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>
                      Procedimiento en caso de financiamiento por donación o contratos de préstamos, para la adquisición a través de
                      Licitación Pública Internacional:
                    </strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Una vez verificado que la necesidad institucional corresponde a uno de los servicios ofrecidos a través del Catálogo y,
                    cuya fuente de financiamiento o recurso trate de donación, cooperación y/o financiamiento por préstamos con organismos
                    multilaterales, la Institución podrá publicar una Solicitud de Expresión de Interés, que consistirá en una convocatoria
                    pública para ofertar, abierta a la participación de entidades nacionales y extranjeras para la adquisición de bienes o
                    servicios que faciliten o promuevan al transformación digital del Estado.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    La Solicitud de Expresión de Interés será difundida, tanto en medios de comunicación nacionales como internacionales,
                    promoviendo una amplia participación y diversidad de proponentes. Además, podrán realizarse invitaciones y
                    notificaciones a proveedores del Estado que la institución considere pertinente en atención a la naturaleza del
                    requerimiento.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Todos los proponentes tendrán las mismas oportunidades de participar sin restricciones relacionadas con el origen de los
                    bienes o servicios ofrecidos. Las condiciones de participación y evaluación serán equitativas y no discriminatorias para
                    todos los participantes.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    La información relacionada con la Solicitud de Expresión de Interés será clara, precisa y accesible. Los documentos
                    pertinentes detallarán las características, fases, plazos, normativas aplicables, criterios de evaluación y selección, y
                    condiciones generales y particulares del proceso
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    El proceso buscará obtener las propuestas más favorables en el mercado, fomentando la participación de todos los
                    potenciales proponentes, sin restricciones, salvo aquellas establecidas por ley o regulaciones aplicables.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Propuestas que proceden de la Alianza Estratégica:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    En los casos que aplique, una vez notificado el requerimiento al Socio Estratégico, este mismo y cualquiera de los
                    proveedores establecidos en el numeral 1 del romano VII enviará su propuesta dentro del plazo otorgado por la
                    institución, mismo que, de conformidad a la naturaleza del servicio, podrá ser aumentado de oficio o a petición de
                    parte. Durante el referido plazo, podrá mantenerse comunicación directa entre estos y la institución requirente con el
                    objetivo de contar con la información oportuna para generar la propuesta técnica y económica.
                  </Typography>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Regla para la evaluación de propuestas derivadas de la Alianza Estratégica:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Una vez obtenida la cotización en el Portal Web o recibida la propuesta se convocará a el (los) evaluador (es), quienes
                    determinarán si al cotización o propuesta es la más favorable para la institución, evaluando lo siguiente:
                  </Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        Cumple con las especificaciones técnicas establecidas por la institución.
                      </Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>Satisface las necesidades planteadas por la institución.</Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        El oferente es el Socio Estratégico, Partners, socios o distribuidores Calificados o terceros proveedores de
                        Servicios y Software establecidos en el Google Cloud Marketplace conforme a lo establecido en el romano VI, numeral
                        1, de las Consideraciones Preliminares del presente lineamiento.
                      </Typography>
                    </li>
                  </ol>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Una vez finalizada la evaluación se emitirá informe donde se determinará si la propuesta del Socio Estratégico, partner,
                    socio o distribuidor calificado y/o terceros proveedores es la más favorable, pudiendo concurrir las circunstancias
                    siguientes:
                  </Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        La propuesta del oferente resulta como la más favorable: En este caso, la institución continúa con el paso regulado
                        en el numeral 8 del presente apartado
                      </Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        La propuesta se considera menos favorable a lo comercialmente aceptable: Bajo esta circunstancia, la institución
                        podrá solicitar al revisión de la propuesta al Oferente y notificará al Gerente de la Alianza. En caso de no obtener
                        una propuesta favorable para la institución, quedará habilitada para realizar el procedimiento que conforme a la ley
                        corresponda.
                      </Typography>
                      <br />
                    </li>
                  </ol>
                  <Typography style={{ fontSize: 15 }}>
                    La evaluación debe hacerse dentro de un plazo máximo de 5 días hábiles, contados a partir del día siguiente a la fecha
                    de generación de la cotización o recepción de la propuesta.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>
                      Regla Especial para la evaluación de propuestas provenientes del Procedimiento de Licitación Pública Internacional
                    </strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Licitación Pública Internacional En aquellos supuestos en los que se hayan recibido ofertas a través de Solicitud de
                    Expresión de Interés establecido en numeral 4, romano VI en caso de financiamiento por donación o contratos de préstamos
                    con organismos multilaterales, el (los) evaluador (es) podrá determinar si la cotización o propuesta es la más favorable
                    para la institución conforme a los criterios siguientes:
                  </Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        <strong>Cumplimiento de especificaciones técnicas:</strong> Los oferentes deberán comprobar que cumplen con las
                        especificaciones técnicas establecidas por la Institución contratante. La veracidad de las especificaciones de los
                        bienes ofertados, deberán comprobarse por medio de catálogos, brochures o cualquier otro documento del oferente en
                        idioma castellano.
                      </Typography>
                    </li>
                    <br />
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        <strong>Relación calidad-precio: </strong>Se deben establecer criterios de calidad claros y objetivos, desarrollados
                        con la colaboración entre la Unidad Solicitante y la Unidad de Compras. Estos criterios deben ser relevantes para
                        los requisitos del bien o servicios, proporcionales al valor y objetivos del contrato, y sin ambigüedades.
                      </Typography>
                      <br />
                      <Typography style={{ fontSize: 15 }}>
                        La calidad puede fomentar la innovación al tener especificaciones técnicas abiertas con resultados definidos,
                        permitiendo que los oferentes propongan soluciones innovadoras.
                      </Typography>
                      <br />
                      <Typography style={{ fontSize: 15 }}>
                        Los criterios de calidad deben tener ponderaciones proporcionales en función de su importancia en el contrato y sus
                        objetivos. Se deberá diseñar un enfoque de puntuación que permita una clara diferenciación entre las respuestas del
                        oferente a los criterios de calidad.
                      </Typography>
                      <br />
                      <Typography style={{ fontSize: 15 }}>
                        Así mismo, el precio constituirá un elemento esencial para determinar la oferta más favorable, para lo cual la
                        institución deberá evaluar el precio de manera justa y transparente, evitando favorecer ofertas de bajo costo o
                        anormalmente bajas y considerar los costos a lo largo de la vida útil del bien o servicio en beneficio de la
                        institución.
                      </Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        <strong>Responsabilidad social y ambiental: </strong> Las instituciones deberán priorizar la compra de productos con
                        un ciclo de vida útil más largo, adquisición de productos que cuenten con su respectivo mantenimiento, y que cumplan
                        con criterios de calidad, sostenibilidad y eficiencia energética.
                      </Typography>
                    </li>
                  </ol>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Durante la evaluación, las Instituciones podrán mantener comunicación con el (los) oferente(s) con el objetivo de
                    obtener y/o comprender los elementos necesarios para concluir la evaluación, dejando constancia de dicha comunicación en
                    el expediente de la contratación con base al principio de transparencia regulado en estos lineamientos.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Una vez finalizada la evaluación se emitirá el informe de determinación de la propuesta más favorable, pudiendo
                    concurrir los casos siguientes:
                  </Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        En caso de recibirse propuestas más favorables que las provenientes de la Alianza Estratégica o que este último no
                        haya enviado su propuesta, se procederá a realizar un proceso de contratación bajo la legislación correspondiente.
                      </Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>
                        En caso de que la propuesta presentada por el oferente a través de la Alianza Estratégica sea la más favorable o que
                        sea la única propuesta y que esta cumpla con los criterios de evaluación establecidos se continuará con la
                        verificación de la disponibilidad presupuestaria o financiera y finalmente se emitirá la orden de pedido
                        correspondiente.
                      </Typography>
                      <br />
                    </li>
                  </ol>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    La máxima Autoridad de la institución o su delegado, podrá aprobar el informe a que se refiere el párrafo que antecede,
                    observarlo para que los evaluadores subsanen vicios de forma y fondo, o rechazarlo y razonar su evaluación. El resultado
                    de la evaluación que hace referencia este apartado será notificado a todos los proponentes.
                  </Typography>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Disponibilidad Financiera</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Las solicitudes de compra podrán contener o ir acompañadas de la asignación presupuestaria o financiera correspondiente,
                    o podrá ser requerida e incorporada una vez se finalice la evaluación cuyo informe determine que la propuesta derivada
                    de la Alianza Estratégica resulta más favorable para la institución.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Dicha disponibilidad podrá ser modificada en cualquier momento de acuerdo a las necesidades institucionales hasta antes
                    de generar la orden de pedido.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Emisión y suscripción de la orden de pedido</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Cuando sea procedente, la Unidad Solicitante a través del Representante Institucional remitirá a la Unidad de Compras
                    Públicas (UCP) el expediente del procedimiento administrativo, que como mínimo contendrá:
                  </Typography>
                  <br />
                  <ol type="a">
                    <li>
                      <Typography style={{ fontSize: 15 }}>el requerimiento inicial,</Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>la propuesta del Socio Estratégico,</Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>el informe de evaluación, y</Typography>
                      <br />
                    </li>
                    <li>
                      <Typography style={{ fontSize: 15 }}>a disponibilidad presupuestaria o financiera,</Typography>
                    </li>
                    <br />
                    <Typography style={{ fontSize: 15 }}>
                      La UCP recibirá y registrará el expediente administrativo y procederá a gestionar la emisión de orden de pedido a
                      través del Portal Web desarrollado por el Socio Estratégico o a través de comunicación por medios físicos o
                      electrónicos con el oferente.
                    </Typography>
                    <br />
                    <Typography style={{ fontSize: 15 }}>
                      La suscripción de esta orden será procedente cuando se cuente con recomendación favorable o, en su defecto, el
                      razonamiento del titular o delegado, y la certificación de disponibilidad presupuestaria o financiera, siendo este
                      último la Autoridad competente para la suscripción de la referida orden.
                    </Typography>
                  </ol>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Impugnación</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    En los casos que las instituciones hayan solicitado Expresiones de Interés, los proponentes dispondrán de dos (2) días
                    para interponer &ldquo;Escrito de Inconformidad&ldquo; en el cual deberán exponer de manera clara los argumentos de su
                    disensión, de conformidad a los criterios evaluados y a su propuesta presentada.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Recibido el escrito, al institución convocará al (los) evaluador (es) que conocieron las propuestas, uno o más
                    evaluadores de parte de la Unidad Solicitante o Área Técnica, quienes evaluarán el escrito y sus elementos y decidirán
                    si se mantiene la elección de la Oferta más favorable o se modifica. Esta decisión pasará a aprobación de la máxima
                    Autoridad de la institución o su delegado y posteriormente deberá ser notificada a los interesados. El procedimiento
                    anterior deberá realizarse en un plazo no mayor a diez (10) días hábiles a partir de la recepción del escrito hasta al
                    notificación del resultado.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Distribución de la orden de pedido:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Una vez suscrita al orden de pedido, deberá distribuirse a todos los intervinientes.
                  </Typography>
                </li>
                <br />
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Modificaciones:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Las partes podrán negociar y suscribir modificaciones a las órdenes de pedido reguladas en estos lineamientos, durante
                    el plazo establecido para la ejecución de las obligaciones, dejándose constancia escrita de la negociación y acuerdo de
                    las partes.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Salvo que se describa específicamente lo contrario en la Orden de Pedido, sus modificaciones deben hacerse por escrito,
                    establecer explícitamente que modifican al orden y estar firmadas por las dos partes.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Asimismo, el proveedor podrá modificar los precios en cualquier momento, sin embargo, cuando se trate de aumento deberá
                    acreditar las circunstancias que lo justifiquen y notificar a la institución con al menos treinta (30) días de
                    anticipación previo a la materialización del aumento, debiendo este último manifestar su aceptación en un plazo no mayor
                    a veinte (20) días posteriores a la recepción de la notificación aquí mencionada.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Previo a la aceptación de aumento, la institución deberá asignar el presupuesto o recursos adicionales o solicitar la
                    reducción del servicio, en caso que no se cuente con la disponibilidad financiera correspondiente y que la naturaleza
                    del servicio lo permita.
                  </Typography>
                </li>
              </ol>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Verificación de cumplimiento de Órdenes de Pedido</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Las Instituciones que hayan emitido órdenes de pedido designarán un supervisor de la orden de pedido, quien tendrá las
                responsabilidades siguientes:
              </Typography>
              <br />
              <ol type="a">
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    Verificar el cumplimiento de las cláusulas y/o condiciones de la orden de pedido.
                  </Typography>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    Elaborar oportunamente los informes de avance de la ejecución de entregas de las órdenes de pedido, acorde a ol
                    establecido en el requerimiento o a petición de la Unidad Solicitante o funcionario competente.
                  </Typography>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    Elaborar y suscribir juntamente con el Oferente, las actas de recepción total o parcial de las entregas realizadas en
                    virtud de las órdenes de pedido, pudiendo suscribirlas mediante el uso del Portal Web o cualquier otro medio
                    electrónico.
                  </Typography>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    Informar y remitir a la UCP y al representante de la entidad, copia de las actas de recepción y de los informes que
                    hubieran sido elaborados.
                  </Typography>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    Cualquier otra responsabilidad que se establezca en las especificaciones técnicas del servicio, orden de pedido, o
                    acordado por los órganos de administración de la Alianza
                  </Typography>
                  <br />
                </li>
              </ol>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Para cada orden de pedido se deberá nombrar un supervisor para verificación del cumplimiento, asimismo y dependiendo de al
                complejidad, volumen y otros parámetros según la naturaleza de la contratación, se podrá designar a más de un supervisor
                para la orden de pedido. Las responsabilidades designadas a los supervisores, se considerarán parte d las funciones y
                atribuciones del cargo que desempeñan, ya que estos serán parte de personal de la institución y que tengan conocimientos o
                experiencia relacionada con el objeto contractual.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Tratamiento financiero</strong>
              </Typography>
              <br />
              <ol>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Presupuesto:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Las entidades del Estado deberán atender la normativa emitida por el Ministerio de Hacienda relativa a la formulación
                    presupuestaria, con el fin que cada institución pueda afrontar los compromisos que adquieran las instituciones del
                    Estado con los proveedores derivados de la Alianza Estratégica
                  </Typography>
                  <br />
                </li>
                <li>
                  <Typography style={{ fontSize: 15 }}>
                    <strong>Pago y Anticipo:</strong>
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    Las órdenes de pedido contendrán las reglas de la forma de pago, quedando facultadas las instituciones para aceptar
                    compromisos de pago anticipado por los servicios y condiciones de crédito hasta 30 días.
                  </Typography>
                  <br />
                  <Typography style={{ fontSize: 15 }}>
                    El supervisor de la orden de pedido generará o solicitará la factura o documento equivalente a través del Portal Web,
                    misma que junto con el acta de recepción, remitirá a la Unidad Financiera Institucional (UFI)o quien haga sus veces.
                  </Typography>
                  <br />
                </li>
              </ol>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Terminación de la orden de pedido</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                La institución podrá cancelar al orden de pedido si la otra parte ha incumplido sustancialmente con una de sus obligaciones
                y no subsana dicho incumplimiento dentro de los 30 días calendario contados a partir del día siguiente de la recepción de
                una notificación escrita. En este caso, la institución deberá notificar el incumplimiento al Gerente de la Alianza.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Solución de controversias</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Los conflictos derivados de la ejecución contractual serán sometidos a un Trato Directo, en caso de no solucionarse, deberán
                someterse ante el Gerente de la Alianza, quien contará con un plazo de sesenta (60) días para resolver la controversia antes
                de escalarla ante el Comité Directivo Conjunto, quién a su vez, dispondrá de un plazo máximo de sesenta (60) días para
                resolver.
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Todas las Controversias que permanezcan sin resolver por el Comité Ejecutivo una vez vencido el plazo que dispone serán
                sometidas a arbitraje según lo establecido en el Acuerdo Maestro de Google Cloud.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Expediente</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                El Representante Institucional será el responsable de consolidar el expediente administrativo de los procesos ejecutados
                bajo este lineamiento. La Unidad Solicitante yel Supervisor de la Orden de Pedido serán responsables de informar
                oportunamente al Representante Institucional. Concluidos los procedimientos, los expedientes respectivos podrán remitirse al
                área o unidad responsable del archivo institucional.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Uso de sistemas electrónicos</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Salvo las excepciones establecidas en este lineamiento, no será obligatorio el uso de COMPRASAL para el desarrollo del
                procedimiento administrativo. El procedimiento tendrá una combinación de etapas realizadas mediante documentos físicos o
                electrónicos institucionales y el uso del Portal Web habilitado por el Socio Estratégico, hasta el momento que se disponga
                del desarrollo institucional vinculado al Portal Web del Socio Estratégico.
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Además, a falta de las habilitaciones o componentes del Portal Web podrán realizarse los actos a través de medios impresos o
                electrónicos, mientras se cuenta con los desarrollos correspondientes
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Uso de la Firma Electrónica</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Las autoridades, funcionarios y empleados del Estado que presten servicios públicos, ejecuten o realicen actos dentro de us
                ámbito de competencia, conforme a lo establecido en el presente lineamiento podrán suscribirlos por medio de firma
                electrónica simple.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Publicidad</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Cuando sea procedente, las compras efectuadas bajo este lineamiento deberán ser divulgadas en los medios en que es publicó
                la Solicitud de Expresión de Interés y/o el Portal Web que determine al legislación nacional en materia de acceso a la
                información.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Confidencialidad</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                La regla de manejo de información confidencial regulada en la Alianza Estratégica es la siguiente:
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                El destinatario solo utilizará al Información confidencial de la Parte reveladora para ejercer sus derechos y cumplir sus
                obligaciones en virtud del Acuerdo y actuará con la diligencia razonable para protegerse contra la revelación de la
                Información confidencial de la Parte reveladora. Además, Google protegerá los Datos del cliente tal ycomo se describe en el
                Anexo de servicios aplicable.
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Sin perjuicio de cualquier otra disposición del Acuerdo, el destinatario podrá revelar al Información Confidencial de al
                Parte Reveladora (a) a sus delegados que necesiten conocerla y que estén sujetos a obligaciones de confidencialidad al menos
                tan protectoras como las descritas en el Acuerdo Maestro de Google Cloud (b) con el consentimiento por escrito de la Parte
                Reveladora; y según sea estrictamente necesario para cumplir con algún Proceso Legal.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Medidas anticorrupción</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Los sujetos intervinientes en el proceso de compra regulado por este lineamiento están obligados a mantener conductas
                antisoborno y anticorrupción, así como abstenerse de realizar actos anticompetitivos en perjuicio de la Administración
                Pública
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                Las contrataciones realizadas bajo el procedimiento establecido en el presente lineamiento estarán sujetas a las auditorías
                establecidas por las leyes y reglamentos correspondientes.
              </Typography>
            </li>
            <br />
            <li>
              <Typography style={{ fontSize: 15 }}>
                <strong>Modificación de lineamientos</strong>
              </Typography>
              <br />
              <Typography style={{ fontSize: 15 }}>
                El Ministerio de Relaciones Exteriores podrá modificar los presentes lineamientos en caso de ser necesario, de conformidad a
                lo previsto en la Ley General para la Modernización Digital del Estado, la Alianza Estratégica y sus enmiendas, el Acuerdo
                Maestro de Google Cloud, y cualquier otro compromiso que adquiera con el Socio Estratégico.
              </Typography>
            </li>
            <br />
          </ol>
        </div>
      </div>
    </>
  );
};
